'use strict';

require('react');
var identifier = require('./identifier.cjs');
var jsxRuntime = require('react/jsx-runtime');
var ThemeProvider = require('../../node_modules/@mui/system/esm/ThemeProvider/ThemeProvider.cjs');

function ThemeProviderNoVars({
  theme: themeInput,
  ...props
}) {
  const scopedTheme = identifier in themeInput ? themeInput[identifier] : undefined;
  return /*#__PURE__*/jsxRuntime.jsx(ThemeProvider, {
    ...props,
    themeId: scopedTheme ? identifier : undefined,
    theme: scopedTheme || themeInput
  });
}

module.exports = ThemeProviderNoVars;
//# sourceMappingURL=ThemeProviderNoVars.cjs.map
